import { useState } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

const FAQ = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <article className={`faq ${isOpen ? "open" : ""}`}>
      <button
        className="faq__header"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <h4>{question}</h4>
        <span className="faq__icon">
          {isOpen ? <AiOutlineMinus /> : <AiOutlinePlus />}
        </span>
      </button>

      {isOpen && (
        <div className="faq__content">
          <p>{answer}</p>
        </div>
      )}
    </article>
  );
};

export default FAQ;
